var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "basic-container",
    [
      _c(
        "el-row",
        { attrs: { span: 24 } },
        [
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [_c("v-chart", { attrs: { options: _vm.useKeyCumulate } })],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c("avue-data-display", {
                attrs: { option: _vm.infomationCumulate },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-row",
        { attrs: { span: 24 } },
        [
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [_c("v-chart", { attrs: { options: _vm.memoryCumulate } })],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [_c("v-chart", { attrs: { options: _vm.dbSizeCumulate } })],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }